import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import { snippetRef } from './consts';

export default grapesjs.plugins.add('zerocode-snippet', (editor, opts = {}) => {
  let defaults = {
    blocks: [snippetRef],
    labelSnippetCategory: 'Advanced',
    labelSnippet: 'Snippet',
    pfx: 'snippet',
  };

  for (let name in defaults) {
    if (!(name in opts)) opts[name] = defaults[name];
  }

  loadComponents(editor, opts);
  loadBlocks(editor, opts);
});
